// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.core--date-display{color:var(--N700)}`, "",{"version":3,"sources":["webpack://./../ZaddonsJSLibs/common-client2/src/components/v1/DateDisplay/DateDisplay.scss"],"names":[],"mappings":"AACA,oBACI,iBAAA","sourcesContent":["\r\n.core--date-display {\r\n    color: var(--N700);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
